import axios from 'axios';
import { ReferenciaEnarm } from '../Models/ReferenciaEnarm';

// Usa la instancia global de axios (interceptores con el bearer token en services/index.ts)
class ReferenciaEnarmService {
  // Referencia activa (cualquier usuario autenticado)
  async getActiva(): Promise<ReferenciaEnarm | null> {
    const response = await axios.get<ReferenciaEnarm | null>('/api/enarm/referencia');
    return response.data ?? null;
  }

  // Listado completo (admin)
  async listar(): Promise<ReferenciaEnarm[]> {
    const response = await axios.get<ReferenciaEnarm[]>('/api/admin/enarm/referencias');
    return response.data;
  }

  // Crear / actualizar (admin)
  async guardar(ref: ReferenciaEnarm): Promise<ReferenciaEnarm> {
    const response = await axios.post<ReferenciaEnarm>('/api/admin/enarm/referencia', ref);
    return response.data;
  }

  // Eliminar (admin)
  async eliminar(id: number): Promise<void> {
    await axios.delete(`/api/admin/enarm/referencia/${id}`);
  }
}

export const referenciaEnarmService = new ReferenciaEnarmService();
